import { render, staticRenderFns } from "./packageRemindTime.vue?vue&type=template&id=75688f97&scoped=true"
import script from "./packageRemindTime.vue?vue&type=script&lang=js"
export * from "./packageRemindTime.vue?vue&type=script&lang=js"
import style0 from "./packageRemindTime.vue?vue&type=style&index=0&id=75688f97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75688f97",
  null
  
)

export default component.exports